/*
  gm-lazyvideo.js — defer below-fold autoplay videos until they approach the viewport.

  The markup ships a poster <img> plus the real <video> inside a <template>. Browsers do
  NOT load resources inside a <template>, so nothing is fetched until we inject it as a tile
  nears the viewport. The container reserves its own box (aspect-ratio on .video-grid-item),
  so hydration causes no layout shift. Ported for GripMate from the sister-site pattern.
*/
(function () {
  if (window.__gmLazyVideoInit) return;
  window.__gmLazyVideoInit = true;

  var SEL = '[data-gm-lv]';

  function hydrate(el) {
    if (el.hasAttribute('data-gm-lv-done')) return;
    el.setAttribute('data-gm-lv-done', '');

    var tpl = el.querySelector('template[data-gm-lv-tpl]');
    if (!tpl) return;

    el.insertAdjacentHTML('beforeend', tpl.innerHTML);
    tpl.parentNode.removeChild(tpl);

    var video = el.querySelector('video');
    if (!video) return;

    /* Keep the poster until there are real frames, then drop it so it can't
       sit on top of the video or linger as a stale first frame. */
    var poster = el.querySelector('.gm-lv-poster');
    var reveal = function () {
      el.classList.add('gm-lv-ready');
      if (poster && poster.parentNode) poster.parentNode.removeChild(poster);
    };
    video.addEventListener('loadeddata', reveal, { once: true });

    /* The template markup carries `autoplay`, but a node injected after parse
       doesn't always honour it; call play() and swallow the rejection that
       browsers throw when autoplay is disallowed. */
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  /* Start fetching a bit before it scrolls in so it's playing on arrival. */
  var MARGIN = 400;

  function stillInRange(el) {
    var b = el.getBoundingClientRect();
    if (!b.width && !b.height) return false;
    return b.top - window.innerHeight < MARGIN && b.bottom > -MARGIN;
  }

  function sweep() {
    var pending = document.querySelectorAll(SEL + ':not([data-gm-lv-done])');
    Array.prototype.forEach.call(pending, function (el) {
      if (stillInRange(el)) hydrate(el);
    });
    return pending.length;
  }

  var sweepTimer = null;
  function scheduleSweep() {
    if (sweepTimer) return;
    /* setTimeout, NOT rAF: rAF is suspended while the document is hidden, which
       would strand every video permanently unhydrated. A timer still fires. */
    sweepTimer = setTimeout(function () {
      sweepTimer = null;
      if (sweep() === 0) teardown();
    }, 50);
  }

  var listening = false;
  function teardown() {
    if (!listening) return;
    listening = false;
    window.removeEventListener('scroll', scheduleSweep);
    window.removeEventListener('resize', scheduleSweep);
  }

  function boot() {
    if (!document.querySelector(SEL)) return;

    if (!listening) {
      listening = true;
      window.addEventListener('scroll', scheduleSweep, { passive: true });
      window.addEventListener('resize', scheduleSweep, { passive: true });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) scheduleSweep();
      });
      window.addEventListener('pageshow', scheduleSweep);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var any = entries.some(function (e) {
            return e.isIntersecting;
          });
          if (any) scheduleSweep();
        },
        { rootMargin: MARGIN + 'px 0px' }
      );
      Array.prototype.forEach.call(document.querySelectorAll(SEL), function (el) {
        io.observe(el);
      });
    }

    scheduleSweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders sections without a full page load. */
  document.addEventListener('shopify:section:load', boot);
})();
